import { useArticle } from 'apis/query';
import { ArrowLeft } from 'assets/icons';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import styles from './Detail.module.css';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export default function ArticleDetail({ slug, category }) {
  const { isLoading, data: article } = useArticle({ slug, category });
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{article?.title}</title>
        <meta name="title" content={article?.title} />
        <meta name="description" content={article?.description} />
        <meta name="keywords" content={`electrum, motor listrik, EV, artikel, ${category}, ${article?.title}`} />
        <meta property="og:title" content={article?.title} />
        <meta property="og:description" content={article?.description} />
        <link
          rel="canonical"
          href={`https://electrum.id/${category}/detail/${slug}`}
        />
      </Helmet>
      <div className={styles.container}>
        <div className={styles.backButtonContainer}>
          <div
            onClick={() => navigate(`/${category}`)}
            className={styles.backButton}
          >
            <ArrowLeft fill="#fff" width="20" height="20" />
            <span>Back to</span>
            <span
              style={{
                marginLeft: '5px',
                textTransform: 'capitalize',
              }}
            >
              {category}
            </span>
          </div>
        </div>

        {isLoading || article === undefined ? (
          <div className={styles.loading}>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
            />
          </div>
        ) : (
          <article>
            <div className={styles.title}>{article?.title}</div>
            {(article?.author || article?.date) && (
              <div className={styles.meta}>
                <b>{article?.author}</b> · {article?.date}
              </div>
            )}
            <img
              loading="lazy"
              alt="news-img"
              src={article?.image}
              className={styles.image}
            />
            <div className={styles.content}>
              <div
                contentEditable={false}
                dangerouslySetInnerHTML={{
                  __html: article?.content,
                }}
              />
            </div>
            {article?.source !== '' && (
              <div className={styles.source}>
                Check out the full blog at{' '}
                <a href={article?.source} target="_blank" rel="noreferrer">
                  {article?.source_alias || article?.source}
                </a>
              </div>
            )}
          </article>
        )}
      </div>
    </>
  );
}
